import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import SizeGuideModal from "../../components/sizeGuideModal/SizeGuideModal";
import BackInStockLoginModal from "../../components/backInStock/BackInStockLoginModal";
import LooksModal from "../../components/looks/LooksModal";
import SeeSimilarModal from "../../components/looks/seeSimilarModal/SeeSimilarModal";
import RecommendedOutfitsModal from "../../components/recommendedOutfits/RecommendedOutfitsModal";
import WaysToStyleModal from "../../components/waysToStyle/WaysToStyleModal";

export default function AppModals() {
  const { isMixAndMatch, isMobile } = useRuntimeConstants();

  return (
    <>
      <SizeGuideModal />
      {!isMixAndMatch && (
        <>
          {isMobile && <LooksModal />}
          {isMobile && <RecommendedOutfitsModal />}
          {isMobile && <WaysToStyleModal />}
          <SeeSimilarModal />
        </>
      )}
      <BackInStockLoginModal />
    </>
  );
}
